import { BaseConfig } from '../ServiceConfig';

export interface PVISConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.PvisServiceConfigData';
  url: string;
}

export const PVISConfigurationFields: (keyof PVISConfiguration)[] = ['url'];

export const BlankPvisConfiguration: PVISConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.PvisServiceConfigData',
} as PVISConfiguration;
